export default "__VITE_ASSET__CejtcgvF__"